module.exports = __webpack_public_path__ + "static/fipcunicornmain-5d3688feb077183cd533435537ae2010.jpeg";